import { BaseFieldView } from '../BaseField/views';

export const NumberFieldView = BaseFieldView.extend({
    events: {
        'keypress input': 'strip_non_digits',
        'change input, blur input': 'save_value'
    },

    /**
     * This problem is a nightmare. Number fields act very differently across devices.  We attempt
     * to handle all error checking here and not let bad characters get in.  Some phones let them in but not save (iOS)
     * and some phones dont even let them in.  This method helps us normalize behavior.
     *
     * @returns true if typed character is allowed, false if not
     */
    strip_non_digits: function (event) {
        if (event.keyCode == 0) {
            return true;
        } // crappy browsers can't validate, seen on FF
        if (event.keyCode >= 48 && event.keyCode <= 57) {
            return true;
        } // [0-9]
        if (event.keyCode == 45 && event.target.value.indexOf('-') == -1) {
            return true;
        } // "-" for negative numbers & only allow one
        if (event.target.value.indexOf('.') > -1) {
            return false;
        } // only allow one period through
        if (event.keyCode == 46 || event.keyCode == 8) {
            return true;
        } // [\.] or backspace
        return false;
    },

    save_value: function (event) {
        // remove commas from input before saving
        event.target.value = event.target.value.replace(/,/g, '');
        this.fix_event_val_leading_decimal(event);
        NumberFieldView.__super__.save_value.call(this, event);
    },

    fix_event_val_leading_decimal: function (event) {
        /**
         * Backbone Validation has a bug where it will not accept numbers with leading decimals,
         * (https://github.com/thedersen/backbone.validation/issues/103) so let's insert a "0"
         * before saving if that's the case.
         */
        var val = $(event.target).val();
        if (val.indexOf('.') == 0) {
            $(event.target).val('0' + val); // .9 --> 0.9
        } else if (val.indexOf('.') == 1 && val.indexOf('-') == 0) {
            $(event.target).val(`${val.substr(0, 1)}0${val.substr(1)}`); // -.9 --> -0.9
        }
    }
});
